import { Loader } from '@components/Loader';
import { useState, useEffect } from "react";
import i18n from "i18next";
import styles from './Captcha.module.scss';

const Captcha = ({ onChange }: {
  onChange: (ticket: string, randstr: string) => void,
}) => {
  const currentLanguage = i18n.language;
  const [isReady, setIsReady] = useState(false);

  const handleCallBack = (res: any) => {
    if (res.ret === 0) {
      onChange(res.ticket, res.randstr);
    } else {
      onChange("", "");
    }
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://ca.turing.captcha.qcloud.com/TJNCaptcha-global.js';
    script.async = true;
    script.onload = () => {
      setIsReady(true);
    };
    script.onerror = () => {
      console.error('Script failed to load.');
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    let captcha: any = undefined;
    if (isReady) {
      captcha = new TencentCaptcha(
        document.getElementById('cap_iframe'),
        '189920197',
        handleCallBack,
        {
          userLanguage: currentLanguage === "cn" ? "zh-cn" : currentLanguage,
        },
      );
      captcha.show();
    }
    return () => {
      captcha && captcha.destroy();
    }
  }, [isReady, currentLanguage])

  return (
    <div id="cap_iframe" className={styles.loaderContainer}>
      <div className={styles.loader}>
        <Loader
          alignment="center"
          size="xs"
          dark
        />
      </div>
    </div>
  );
};

export default Captcha;
